export function bookingSourceLabel(source) {
  const src = String(source || '').trim().toLowerCase();
  if (src === 'admin') return 'Panel admin';
  if (src === 'whatsapp') return 'WhatsApp';
  if (src === 'google') return 'Google';
  return 'Sitio web';
}

export function appointmentDetailTitle(patientName, typeLabel) {
  const name = String(patientName || '').trim() || 'Paciente';
  const type = String(typeLabel || '').trim();
  if (type) return `${type} — ${name}`;
  return `Cita — ${name}`;
}

export function appointmentDetailDescription(cell) {
  const reason = String(cell?.reason || '').trim();
  if (reason) return reason;
  const typeLabel = String(cell?.appointment_type_label || 'Cita').trim() || 'Cita';
  const src = bookingSourceLabel(cell?.booking_source);
  return `${typeLabel} (${src})`;
}

export function appointmentEventColorClass(cell) {
  const kind = String(cell?.appointment_kind || 'standard').toLowerCase();
  if (kind === 'review') return 'bg-violet-500/15 border-violet-500/35 text-violet-700 dark:text-violet-300';
  if (kind === 'urgent') return 'bg-orange-500/15 border-orange-500/35 text-orange-800 dark:text-orange-300';
  const status = String(cell?.status || 'pending').toLowerCase();
  if (status === 'confirmed') return 'bg-success/15 border-success/30 text-success';
  if (status === 'completed') return 'bg-primary/15 border-primary/30 text-primary';
  return 'bg-warning/15 border-warning/30 text-warning';
}
